<template>
  <div class="footer">
    <div class="footer-about">
      <div class="footer-content">
        <h2>关于我们：</h2>
        <p>
          一群为儿童设计的人，童心未泯却足够专业。<br />我们充满各种奇思妙想和暖暖的爱意，努力创造孩子真正喜欢的产品。
        </p>
      </div>
    </div>
    <div class="footer-copyright">
      <!-- 网安信息区域 -->
      <p>
        Copyright©2018-{{ new Date().getFullYear() }}
        {{ beiAnZT }}
        <a v-if="beiAnInfo" class="a-link" target="_blank" :href="bUrl">{{ beiAnInfo }}</a>
        <a v-if="wangAnInfo" class="a-link" target="_blank" :href="wUrl">{{ wangAnInfo }}</a>
      </p>
    </div>
  </div>
</template>
<script>
import Deliverer from '@jojosz/config-deliverer'

export default {
  name: 'FooterComponent',
  data() {
    return {
      beiAnInfo: '蜀ICP备2024084283号-1',
      bUrl: 'https://beian.miit.gov.cn/#/Integrated/index',
      wangAnInfo: '',
      wUrl: '',
      beiAnZT: '成都书山有路科技有限公司'
    }
  },
  mounted() {
    this.getBeiAnConfigs()
  },
  methods: {
    // 域名备案 通过运营配置平台【开发者功能】配置获取
    getBeiAnConfigs() {
      try {
        const deliverer = new Deliverer({
          env: 'pro', // 环境变量
          baseTwURL: 'https://api.cdssylkj.com',
          appKey: 'AK7LWBQDIY6', // 应用key目前定义的是 Web公共应用
          scene: 'h5', // 使用场景  目前只有h5 ｜ mp 默认为h5
          appSecret: 'b284ca60d121e996' // 应用secret Web公共应用
        })
        deliverer.fetchConfig('CCMATRIXWEB').then((resData) => {
          const beiAnConfigs = JSON.parse(resData?.data?.configValue?.data || '[]')
          const beiAnData = beiAnConfigs?.find((item) => window.location.host.includes(item?.url))
          if (beiAnData?.beian) {
            this.beiAnInfo = beiAnData?.beian
          }
          if (beiAnData?.burl) {
            this.bUrl = beiAnData?.burl
          }
          this.wangAnInfo = beiAnData?.wangan
          this.wUrl = beiAnData?.wurl
          this.beiAnZT = beiAnData?.unitName
        })
      } catch (e) {
        console.log('e: ', e)
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.footer-about {
  background-color: #fafafa;
  color: #999;
  padding-bottom: 21px;
  display: flex;
  align-items: center;
  justify-content: center;
  .footer-content {
    width: 50%;
    margin: 50px 0;
    box-sizing: border-box;
    p {
      font-size: 20px;
      line-height: 2.2;
      padding-top: 20px;
    }
  }
}
.footer-copyright {
  line-height: 1.4;
  text-align: center;
  margin-top: 30px;
  font-size: 16px;
  color: #999999;
  a {
    color: inherit;
  }
}
</style>
